import { Box, Typography } from '@mui/material';
import { ErrorDisplay } from 'react-components/consents/error-display';
import { useTranslation } from 'react-i18next';

const ConsentsError = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '16px 24px',
        height: '100%',
      }}
    >
      <ErrorDisplay>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography
            component="p"
            variant="bodyMedium"
            fontWeight={700}
            sx={{ fontSize: '18px', lineHeight: '24px' }}
          >
            {t('termsLinkExpiredError.title')}
          </Typography>

          <Typography
            component="p"
            variant="bodyMedium"
            sx={{ fontSize: '14px', lineHeight: '20px' }}
          >
            {t('termsLinkExpiredError.message')}
            <br />
            {t('termsLinkExpiredError.contact')}
          </Typography>
        </Box>
      </ErrorDisplay>
    </Box>
  );
};

export default ConsentsError;
